import React from 'react';
import './TableInterfaces.css';

function TableInterfaces(props) {
  const { iface: { iface, state, link, macaddr, ipaddr } } = props;

  return (
    <tr className='interface-table-row'>
      <td className='interface-cell interface-name-cell'>{ iface.includes('_') ? iface.split('_').join('.') : iface }</td>
      <td className='interface-cell'>{ macaddr }</td>
      <td className='interface-cell'>{ ipaddr }</td>
      <td className='interface-cell'>
        <span className={`status-badge ${state === 'UP' ? 'status-up' : 'status-down'}`}>
          { state }
        </span>
      </td>
      <td className='interface-cell'>{ state === 'DOWN' ? '-' : link }</td>
    </tr>
  );
}

export default TableInterfaces;
